import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Swaps <link rel="manifest"> and <meta name="theme-color"> based on whether
 * the user is on the community side (/community/*) or the org side.
 *
 * Why this matters: when a user installs the PWA from app.socialstar.co/community
 * (Add to Home Screen), the browser reads whichever manifest was attached at
 * install time. By switching the linked manifest before install we make sure
 * the community installation opens directly into /community.
 *
 * No-op outside the browser. Idempotent on route changes.
 */
const ORG_MANIFEST = '/manifest.json';
const ORG_THEME = '#00A79D';
const COMMUNITY_MANIFEST = '/manifest-community.json';
const COMMUNITY_THEME = '#4DB6AC';

export default function ManifestSwitcher() {
  const location = useLocation();
  const isCommunity = location.pathname.startsWith('/community');

  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (link) {
      const target = isCommunity ? COMMUNITY_MANIFEST : ORG_MANIFEST;
      if (link.getAttribute('href') !== target) link.setAttribute('href', target);
    }
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) {
      const target = isCommunity ? COMMUNITY_THEME : ORG_THEME;
      if (themeMeta.getAttribute('content') !== target) themeMeta.setAttribute('content', target);
    }
  }, [isCommunity]);

  return null;
}
